import { FormData } from '../types/form';

const WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/21755273/2wak7u5/';

async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result as string;
      // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
      const base64Content = base64String.split(',')[1];
      resolve(base64Content);
    };
    reader.onerror = error => reject(error);
  });
}

export async function sendToWebhook(formData: FormData, formType: 'CIE' | 'BRIE'): Promise<void> {
  try {
    let fileData = null;
    
    if (formData.billImage) {
      const base64Content = await fileToBase64(formData.billImage);
      fileData = {
        name: formData.billImage.name,
        type: formData.billImage.type,
        size: formData.billImage.size,
        lastModified: formData.billImage.lastModified,
        base64Content
      };
    }

    const payload = {
      formType,
      name: formData.name.trim(),
      lastName: formData.lastName.trim(),
      email: formData.email.trim().toLowerCase(),
      phone: formData.phone.trim(),
      address: formData.address.trim(),
      billImage: fileData,
      submittedAt: new Date().toISOString(),
      userAgent: navigator.userAgent,
      language: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screenSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };

    const response = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      mode: 'no-cors'
    });

    // For no-cors mode or opaque response, treat as success
    if (response.type === 'opaque') {
      return;
    }

    // For normal CORS responses, check status
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Try to parse response if available
    try {
      const data = await response.json();
      if (data && data.error) {
        throw new Error(data.error);
      }
    } catch (e) {
      // Ignore JSON parse errors - not all responses will be JSON
    }
  } catch (error) {
    // Check if it's a URL construction error and treat it as success
    if (error instanceof TypeError && error.message.includes('Failed to construct \'URL\'')) {
      return;
    }
    
    // For all other errors, log and throw
    console.error('Webhook error:', error);
    throw new Error('Error submitting form. Please try again.');
  }
}